<template>
  <el-dialog v-dialogDrag :visible.sync="visible" :close-on-click-modal="false" :close-on-press-escape="false" class="fw" width="900px" top="80px"
    title="组织架构" @closed="$destroy()">
    <div v-loading="loadShow" class="fw-content" element-loading-spinner="fa fa-cog fa-spin"
      element-loading-text="加载中...">
      <div class="fw-tree">
        <el-card shadow="none">
          <template v-slot:header>
            <div class="card-header">
              <span>组织架构</span>
            </div>
          </template>
          <el-tree :data="tree" :props="defaultProps" :expand-on-click-node="false"
            :default-expanded-keys="defaultExpandedKeys" refs="depTree" highlight-current="highlight-current"
            node-key="deptId" @current-change="currentOrgChangeHandler">
            <template #default="{ data }">
              <div class="tree-icon">
                <img :src="icon" alt="" />
                <span>{{ data.deptName }}</span>
              </div>
            </template>
          </el-tree>
        </el-card>
      </div>
      <div class="fw-frame">
        <el-card shadow="none">
          <template v-slot:header>
            <el-input v-model="localQuery.keyword" class="width-200" placeholder="请输入人员名,登录名" clearable
              size="small" @input="getOrgUserList(1)">
              <template suffix="suffix">
                <i class="el-icon-search el-input__icon" @click="getOrgUserList(1)"></i>
              </template>
            </el-input>
          </template>
          <div class="fw-frame-box">
            <div class="fw-frame-item fw-frame-from">
              <p class="fw-frame-title">
                待选人员 (可选
                <span class="text-blue">{{ canSelectLength }}</span> 人)
              </p>
              <person-list :list="personObj.personsFrom" :disabled-list="personObj.personsTo"
                :find-person-index="findPersonIndex" list-name="personsFrom" active-list-name="personsAddActive"
                @item-click="personClickHandler"></person-list>
            </div>
            <div class="fw-btn-group">
              <el-button :disabled="personObj.personsAddActive.length === 0" icon="el-icon-d-arrow-right" size="mini"
                @click="addPersonsTo(personObj.personsAddActive)"></el-button>
              <el-button :disabled="personObj.personsRemoveActive.length === 0" icon="el-icon-d-arrow-left" size="mini"
                @click="personsRemove(personObj.personsRemoveActive)"></el-button>
              <el-button :disabled="canSelectLength === 0" size="mini" @click="addPersonsTo(personObj.personsFrom)">
                全部选中
              </el-button>
              <el-button :disabled="personObj.personsTo.length === 0" size="mini" @click="personsRemove()">
                全部取消
              </el-button>
            </div>
            <div class="fw-frame-item fw-frame-to">
              <p class="fw-frame-title">
                已选人员（已选
                <span class="text-blue">{{ personObj.personsTo.length }}</span>
                人)
              </p>
              <person-list :list="personObj.personsTo" :find-person-index="findPersonIndex"
                active-list-name="personsRemoveActive" @item-click="personClickHandler"></person-list>
            </div>
            <el-pagination :disabled="loadShow" :page-size="pageSize" :total="totalCount" :current-page="pageIndex"
              background layout="total, prev, pager, next" @current-change="getOrgUserList"></el-pagination>
          </div>
        </el-card>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="cancelHandler(true)">取消</el-button>
      <el-button type="primary" size="small" @click="confirmHandler()">确定</el-button>
    </span>
  </el-dialog>
</template>
<script>
import PersonList from "./PersonList";
import org from "@/CommonDP/service/org-service";
import role from "@/CommonDP/service/privi-service";
import { getEnterpriseId } from "@/CommonDP/utils/auth";
export default {
  components: { PersonList },
  data() {
    return {
      icon: require("@/CommonDP/assets/doc/folder_icon.png"),
      visible: false,
      loadShow: false,
      min: 0,
      max: Infinity,
      pageIndex: 1,
      pageSize: 20,
      totalCount: 0,
      ids: [], // 默认用户列表 获取详细后加入到 personsTo
      localQuery: { keyword: "", roleID: "", postName: "" }, // 本地搜索项
      defaultExpandedKeys: [], // 默认展开项
      personObj: {
        personsFrom: [], // 未添加
        personsTo: [], // 已添加
        personsAddActive: [], // 即将添加
        personsRemoveActive: [] // 即将移除
      },
      tree: [], // 树
      searchQuery: { deptId: "" }, // 搜索项
      defaultProps: {
        children: "children",
        label: "deptName"
      }
    };
  },
  computed: {
    enterpriseId() {
      return getEnterpriseId("enterpriseId");
    },
    // 已选的userID集合
    toSet() {
      const {
        personObj: { personsTo }
      } = this;
      const userIDs = new Set();
      for (const { userId } of personsTo) userIDs.add(userId);
      return userIDs;
    },
    // 待选可选 人数
    canSelectLength() {
      const {
        toSet,
        personObj: { personsFrom }
      } = this;
      return personsFrom.filter(({ userId }) => !toSet.has(userId)).length;
    }
  },
  async created() {
    const { getTree, queryListByUserID, reject } = this;
    try {
      await Promise.all([getTree(), queryListByUserID()]);
      this.visible = true;
    } catch (error) {
      reject();
    }
  },
  methods: {
    // 根据userID找到用户
    async queryListByUserID() {
      const { ids } = this;
      if (ids.length > 0) {
        const { data } = await role.queryListByUserID({
          userId: ids.join(",")
        });
        this.personObj.personsTo = data;
      } else {
        this.personObj.personsTo = [];
      }
    },
    // 寻找 用户
    findPersonIndex(person, listName) {
      const { personObj } = this;
      return personObj[listName].findIndex(({ userId }) => person.userId === userId);
    },
    // 点击确认按钮
    confirmHandler() {
      const {
        max,
        min,
        resolve,
        personObj: { personsTo },
        $message
      } = this;
      const { length } = personsTo;
      if (length < min) {
        $message({ message: `人员不得少于${min}人`, type: "error" });
      } else if (length > max) {
        $message({ message: `人员不得多于${max}人`, type: "error" });
      } else {
        resolve(personsTo);
        this.visible = false;
      }
    },
    // 点击取消按钮
    cancelHandler() {
      this.visible = false;
    },
    // 根据id 选中和取消选中
    personClickHandler(person, listName) {
      const { personObj, findPersonIndex } = this;
      const list = personObj[listName];
      const index = findPersonIndex(person, listName);
      if (index === -1) {
        list.push(person);
      } else {
        list.splice(index, 1);
      }
    },
    addPersonsTo(list = []) {
      const {
        toSet,
        personObj,
        personObj: { personsTo }
      } = this;
      const toList = [...personsTo];
      for (const item of list) toSet.has(item.userId) || toList.push(item);
      this.personObj.personsTo = toList;
      personObj.personsAddActive = [];
    },
    personsRemove(list = this.personObj.personsTo) {
      const { personObj, findPersonIndex } = this;
      if (list === personObj.personsTo) personObj.personsTo.splice(0);
      else {
        list.forEach((person) => {
          const index = findPersonIndex(person, "personsTo");
          personObj.personsTo.splice(index, 1);
        });
      }
      personObj.personsRemoveActive = [];
    },
    // 获取左侧单位
    async getTree() {
      const { data } = await org.getOrgTree(this.enterpriseId);
      if (data) {
        this.tree = data;
        this.searchQuery.deptId = data[0].deptId;
        this.defaultExpandedKeys.push(data[0].deptId);
        this.getOrgUserList(1);
      }
    },
    // 获取组织下的人  -  useCache 是否使用缓存
    async getOrgUserList(pageNum = 1) {
      // 添加两个延时 可以使用防止弹框遮住加载提示
      await this.$nextTick();
      // await this.$nextTick();
      const {
        searchQuery: { deptId },
        pageSize,
        localQuery: { keyword },
        enterpriseId
      } = this;
      const params = {
        keyword,
        deptId,
        pageNum,
        pageSize,
        enterpriseId,
        isQueryAll: 1
      };
      const { data, pageIndex, totalCount } = await org.orgUserList(params);
      this.pageIndex = pageIndex;
      this.totalCount = totalCount;
      this.personObj.personsFrom = data || [];
      this.personObj.personsAddActive = [];
    },
    // 选中节点
    async currentOrgChangeHandler(dep = {}) {
      const { searchQuery } = this;
      this.localQuery.keyword = "";
      searchQuery.deptId = dep.deptId;
      await this.getOrgUserList();
    }
  }
};
</script>
<style lang="scss" scoped>
.tree-icon {
  display: flex;
  align-items: center;
  img {
    margin-right: 5px;
  }
  span {
    font-size: 16px;
  }
}
</style>
<style lang="scss" scoped src="./index.scss" />
